import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';
// These are only included when NODE_ENV === 'development'
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import { Toaster } from 'react-hot-toast';
import { Provider, useDispatch } from 'react-redux';
import { LAUNCHDARKLY_KEY } from 'utils/config';
import Routes from './Routes.jsx';
import './global.scss';
import store from './store/store';

const queryClient = new QueryClient();

const App = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <Toaster position="top-center" reverseOrder={false} />
        <Routes />
      </Provider>
      <ReactQueryDevtools initialIsOpen={false} position="bottom-right" />
    </QueryClientProvider>
  );
};

export default withLDProvider({
  clientSideID: LAUNCHDARKLY_KEY,
  options: {
    evaluationReasons: true,
  },
})(App);
